export default __webpack_public_path__ + "static/media/Dialog3.8ab00361.svg";